import { useDispatch, useSelector } from "react-redux";
import { selectSelectedQueryTool, setSelectedQueryTool } from "../data-wrangler/dataWranglerSlice";
import React, { useEffect } from "react";
import FileDownloadDashboard from "./FileDownload/FileDownloadDashboard";
import QueryWizard from "./query-wizard/QueryWizard";
import AdvancedDataWrangler from "../data-wrangler/components/AdvanceDataWrangler/AdvancedDataWrangler";
import { useUserInfoQuery } from "../../api/userApiSlice";
import { useLocation } from "react-router-dom";
import { useGetDatabaseLocationsQuery } from "../../api/databaseApiSlice";
import { setSelectedDatabase } from "../common/databaseSlice";

const DataWrangler = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const selectedQueryTool = useSelector(selectSelectedQueryTool);

    const { data: availableDatabases } = useGetDatabaseLocationsQuery();
    const { data: userData } = useUserInfoQuery({});

    const isGuestUser = userData?.id === -1

    const params = new URLSearchParams(location.search);
    const searchValue = params.get("text") || location.state?.dictSearch;
    const studyValue = params.get("study");
    useEffect(() => {
        if (studyValue) {
            const database = availableDatabases?.find(database => {
                return database.name.toLowerCase().includes(studyValue.toLowerCase())
            });
            if (database) dispatch(setSelectedDatabase(database));
        }
    }, [studyValue, availableDatabases]);

    useEffect(() => {
        if (isGuestUser || searchValue) {
            dispatch(setSelectedQueryTool("dictionary"));
        }
    }, [userData]);

    const renderSections = () => {
        switch (selectedQueryTool) {
        case "queryWizard":
            return (<QueryWizard/>)
        case "dictionary":
            return <AdvancedDataWrangler filterValue={searchValue}/>
        case "allStudyData":
            return (<FileDownloadDashboard/>)
        }
    }

    return (
        renderSections()
    )
}

export default DataWrangler